<script setup lang="ts">
defineProps<{
  avatar: string
  subject: string
  body: string
  timeAgo: string
}>()
</script>

<template>
  <div class="flex items-center space-x-3 rounded-lg border bg-white p-4 text-sm shadow-md">
    <div class="relative shrink-0">
      <img
        :src="avatar"
        class="size-8 rounded-full"
        alt="Avatar"
      />
      <div class="absolute right-0 top-0 size-1.5 rounded-full bg-green-500 ring-2 ring-white" />
    </div>
    <div class="flex min-w-0 grow justify-between space-x-3">
      <div>
        <strong>{{ subject }}</strong><br />{{ body }}
      </div>
      <div class="shrink-0 text-xxs text-supplement">
        {{ timeAgo }}
      </div>
    </div>
  </div>
</template>
